document.addEventListener('click', function(e) {
  if (!(e.target instanceof Element)) return;
  // Handle swatch click (label or input)
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;

  // Only handle if inside a swatch fieldset
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;

  // Find the main and secondary image elements
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;

  // Store original src/srcset/href if not already
  if (!fieldset._originalSrc) {
    fieldset._originalSrc = mainImage.getAttribute('src');
    fieldset._originalSrcset = mainImage.getAttribute('srcset');
    if (secondaryImage) {
      fieldset._originalSecondarySrc = secondaryImage.getAttribute('src');
      fieldset._originalSecondarySrcset = secondaryImage.getAttribute('srcset');
    }
    if (mediaLink) {
      fieldset._originalMediaHref = mediaLink.getAttribute('href');
    }
  }

  // If already checked, do nothing
  if (input.checked) return;

  // Uncheck all, check this one
  fieldset.querySelectorAll('.product-card-robot-swatch-input').forEach(function(i) {
    i.checked = false;
  });
  input.checked = true;

  // Update main image
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);

  // Update secondary image if present
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }

  // Update product-card__media href
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }

  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    quickBuyModal.setAttribute('handle', productHandle);
  }
});

// Preview image and href on hover/focus (event delegation)
document.addEventListener('mouseenter', function(e) {
  if (!(e.target instanceof Element)) return;
  const label = e.target.closest('label.ProductCard--ColorSwatch');
  if (!label) return;
  const input = label.querySelector('input.product-card-robot-swatch-input');
  if (!input) return;
  const fieldset = label.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }


  // --- PRICE UPDATE LOGIC ---
  // Find the price-list element in the product card
  const priceList = productCard.querySelector('.price-list');
  const quickBuyModal = productCard.querySelector('.quick-buy-modal');
  const productHandle = input.getAttribute('data-product-handle');
  if (priceList) {
    
    // Read price and compare-at-price from swatch
    let price = input.getAttribute('data-price');
    let compareAt = input.getAttribute('data-compare-at-price');

    // Build markup
    let priceHtml = '';
    priceHtml += `<sale-price class="${compareAt ? 'text-on-sale' : ''} h6">`;
    priceHtml += `<span class="sr-only">Sale price</span>`;
    priceHtml += price;
    priceHtml += `</sale-price>`;
    if (compareAt) {
      priceHtml += `<compare-at-price class="line-through">`;
      priceHtml += `<span class="sr-only">Regular price</span>`;
      priceHtml += compareAt;
      priceHtml += `</compare-at-price>`;
    }
    priceList.innerHTML = priceHtml;
  }
  if (quickBuyModal && productHandle) {
    quickBuyModal.setAttribute('handle', productHandle);
  }
}, true);

document.addEventListener('focusin', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;
  const newSrc = input.getAttribute('data-src');
  const newSrcset = input.getAttribute('data-srcset');
  if (newSrc) mainImage.setAttribute('src', newSrc);
  if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
  if (secondaryImage) {
    const newSecondarySrc = input.getAttribute('data-secondary-src');
    const newSecondarySrcset = input.getAttribute('data-secondary-srcset');
    if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
    if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
  }
  if (mediaLink) {
    const newProductUrl = input.getAttribute('data-product-url');
    if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
  }
});

// Revert to checked or original on mouseleave/blur (event delegation)
function revertToCheckedOrOriginal(fieldset) {
  const productCard = fieldset.closest('.product-card');
  if (!productCard) return;
  const mainImage = productCard.querySelector('.product-card__image--primary');
  const secondaryImage = productCard.querySelector('.product-card__image--secondary');
  const mediaLink = productCard.querySelector('a.product-card__media');
  if (!mainImage) return;
  const checked = fieldset.querySelector('.product-card-robot-swatch-input:checked');
  if (checked) {
    const newSrc = checked.getAttribute('data-src');
    const newSrcset = checked.getAttribute('data-srcset');
    if (newSrc) mainImage.setAttribute('src', newSrc);
    if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
    if (secondaryImage) {
      const newSecondarySrc = checked.getAttribute('data-secondary-src');
      const newSecondarySrcset = checked.getAttribute('data-secondary-srcset');
      if (newSecondarySrc) secondaryImage.setAttribute('src', newSecondarySrc);
      if (newSecondarySrcset) secondaryImage.setAttribute('srcset', newSecondarySrcset);
    }
    if (mediaLink) {
      const newProductUrl = checked.getAttribute('data-product-url');
      if (newProductUrl) mediaLink.setAttribute('href', newProductUrl);
    }
  } else {
    if (fieldset._originalSrc) mainImage.setAttribute('src', fieldset._originalSrc);
    if (fieldset._originalSrcset) mainImage.setAttribute('srcset', fieldset._originalSrcset);
    if (secondaryImage) {
      if (fieldset._originalSecondarySrc) secondaryImage.setAttribute('src', fieldset._originalSecondarySrc);
      if (fieldset._originalSecondarySrcset) secondaryImage.setAttribute('srcset', fieldset._originalSecondarySrcset);
    }
    if (mediaLink && fieldset._originalMediaHref) {
      mediaLink.setAttribute('href', fieldset._originalMediaHref);
    }
  }
}

document.addEventListener('mouseout', function(e) {
  if (!(e.target instanceof Element)) return;
  // Only handle if leaving a .product-card
  const productCard = e.target.closest('.product-card');
  if (!productCard) return;
  // If moving to a descendant of the same product card, do nothing
  if (e.relatedTarget instanceof Element && productCard.contains(e.relatedTarget)) return;
  // Find the swatch fieldset inside this product card
  const fieldset = productCard.querySelector('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToCheckedOrOriginal(fieldset);
}, true);

document.addEventListener('focusout', function(e) {
  if (!(e.target instanceof Element)) return;
  const input = e.target;
  if (!input.classList.contains('product-card-robot-swatch-input')) return;
  const fieldset = input.closest('.ProductCard--ColorSwatchesFieldset');
  if (!fieldset) return;
  revertToCheckedOrOriginal(fieldset);
});

// Touch-hold to show swatch scroller on product card (mobile UX)
(function() {
  let holdTimer = null;
  let lastScrollTop = 0;
  let activeWrapper = null;
  let touchMoved = false;
  let scrollerOpenedAt = null;
  let observer = null;

  // Hide all swatch scrollers
  function hideAllSwatchWrappers() {
    document.querySelectorAll('.ProductCard--ColorSwatchesFieldsetWrapper').forEach(function(wrapper) {
      wrapper.style.display = 'none';
    });
    activeWrapper = null;
  }

  document.addEventListener('touchstart', function(e) {
    console.log('[touchstart] event on', e.target);
    // Find the closest .product-card or .product-card__figure
    let card = e.target.closest('.product-card');
    if (!card) {
      console.log('[touchstart] No .product-card or .product-card__figure found');
      return;
    }
    console.log('[touchstart] Found card:', card);
    // Find the wrapper inside this card
    let wrapper = card.querySelector('.ProductCard--ColorSwatchesFieldsetWrapper') || (card.classList.contains('product-card') ? card.querySelector('.ProductCard--ColorSwatchesFieldsetWrapper') : null);
    if (!wrapper) {
      console.log('[touchstart] No .ProductCard--ColorSwatchesFieldsetWrapper found in card');
      return;
    }
    console.log('[touchstart] Found wrapper:', wrapper);
    // Prepare for hold
    lastScrollTop = document.scrollingElement.scrollTop;
    touchMoved = false;
    // Start hold timer
    holdTimer = setTimeout(function() {
      let currentScrollTop = document.scrollingElement.scrollTop;
      console.log('[holdTimer] Timer fired. touchMoved:', touchMoved, 'Scroll delta:', Math.abs(currentScrollTop - lastScrollTop));
      if (Math.abs(currentScrollTop - lastScrollTop) < 30 && !touchMoved) {
        console.log('[holdTimer] Showing wrapper (display: flex)');
        hideAllSwatchWrappers();
        wrapper.style.display = 'flex';
        activeWrapper = wrapper;
        // IntersectionObserver to hide if card is out of view
        if (observer) observer.disconnect();
        const productCard = card.classList.contains('product-card') ? card : card.closest('.product-card');
        if (productCard) {
          observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) {
                console.log('[IntersectionObserver] Card out of view, hiding wrapper');
                if (activeWrapper) activeWrapper.style.display = 'none';
                activeWrapper = null;
                if (observer) observer.disconnect();
              }
            });
          }, { threshold: 0.01 });
          observer.observe(productCard);
        }
      } else {
        console.log('[holdTimer] Not showing wrapper due to movement or scroll');
      }
    }, 250);
    console.log('[touchstart] Hold timer set');
  }, { passive: true });

  document.addEventListener('touchmove', function() {
    touchMoved = true;
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
      console.log('[touchmove] Hold timer cleared due to movement');
    }
  }, { passive: true });

  document.addEventListener('touchend', function(e) {
    if (holdTimer) {
      clearTimeout(holdTimer);
      holdTimer = null;
      console.log('[touchend] Hold timer cleared');
    }
    // Optionally, hide on tap outside
    if (activeWrapper && !e.target.closest('.ProductCard--ColorSwatchesFieldsetWrapper')) {
      console.log('[touchend] Hiding active wrapper');
      activeWrapper.style.display = 'none';
      activeWrapper = null;
      if (observer) observer.disconnect();
    }
  });
})();